import { useState, useEffect, useRef, useMemo } from "react";
import { FiTrash2, FiEdit, FiToggleLeft, FiToggleRight, FiX, FiCopy, FiShare2, FiPlus } from "react-icons/fi";
import { CgAdd } from "react-icons/cg";
import { toast } from "react-toastify";
import ToggleSwitch from "../ToggleSwitch";
import Aviso from '../Aviso/index.jsx';
import { useNavigate } from 'react-router-dom';
import api, { baseURL } from "../../services/api";
import styles from './tabvenda.module.css';
import ui from "../../styles/ui.module.css";
import useConfirmDialog from "../ConfirmModal/useConfirmDialog.jsx";
const cx = (...names) => names.filter(Boolean).map((n) => styles[n] || n).join(' ');


// Helper para montar URL do QR Code (sempre relativo à mesma origem)
const getQrUrl = (path) => {
  const file = (path && typeof path === 'string' && path.trim()) ? path.split('/').pop() : '123.jpg';
  return `/api/qrclientes/${file}`; // garante same-origin para evitar CORS/tainted canvas
};

const Tabela = ({ erroAoSalvarVenda, setErroAoSalvarVenda, isLoading, setIsLoading, enviarConfPai, dataList, setDataList, setDataListTabela, dataListTabela, onEdit, onDelete, filtrosDoVendas, toggleFormulario, limparFiltros, setFiltrosDoVendas, tabelaOperacao }) => {
  const { confirm, ConfirmModal } = useConfirmDialog({
    confirmClassName: `${ui.butdesktop} ${ui.btnPrimary}`,
    cancelClassName: ui.butdesktop,
  });
  // Estados removidos: selecionarImg, mostrarLi, logoSelec, logoSelecKey, mostrarListaBrl, mostrarListaBob
  const [conferencia, setConferencia] = useState(false);
  const [vendaMostrarDetalhes, setVendaMostrarDetalhes] = useState(false);
  const [cliVendaMostrarDetalhes, setCliVendaMostrarDetalhes] = useState(null); // Inicializado como null
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [qrcodes, setQrcodes] = useState([]);
  const [qrIndex, setQrIndex] = useState(0);
  const navigate = useNavigate();
  const [showAviso, setShowAviso] = useState(true);
  const [qrFullscreenSrc, setQrFullscreenSrc] = useState(null);
  const [isSharingLink, setIsSharingLink] = useState(false);
  const [isDeletingQr, setIsDeletingQr] = useState(false);

  // Não compomos mais imagens via canvas — enviaremos a imagem original + texto separado

  const handleShareWhats = async () => {
    try {
      const mensagem = getShareMessage();
      // Copia somente o texto para a área de transferência
      let ok = false;
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(mensagem);
        ok = true;
      } else {
        // Fallback para navegadores antigos
        const ta = document.createElement('textarea');
        ta.value = mensagem;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        document.body.appendChild(ta);
        ta.select();
        try { ok = document.execCommand('copy'); } catch { ok = false; }
        document.body.removeChild(ta);
      }
      if (ok) {
        toast.success('Texto copiada para a área de transferência.');
      } else {
        // Último recurso: apresenta um prompt para o usuário copiar manualmente
        window.prompt('Copie a mensagem:', mensagem);
      }
    } catch (e) {
      toast.error('Não foi possível copiar a mensagem.');
    }
  };

  const getShareMessage = (link) => {
    const valorBob = Number(cliVendaMostrarDetalhes?.VALORBOB || 0);
    const base = `Posso transferir seus ${fmtBOB.format(valorBob)} nessa mesma conta de sempre?`;
    return link ? `${base} ${link}` : base;
  };

  const loadImageSafe = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = src;
    });

  const wrapText = (ctx, text, x, y, maxWidth, lineHeight) => {
    const words = String(text || "—").split(" ");
    let line = "";
    let currentY = y;
    words.forEach((word) => {
      const testLine = line ? `${line} ${word}` : word;
      if (ctx.measureText(testLine).width > maxWidth && line) {
        ctx.fillText(line, x, currentY);
        line = word;
        currentY += lineHeight;
      } else {
        line = testLine;
      }
    });
    if (line) {
      ctx.fillText(line, x, currentY);
    }
    return currentY;
  };

  const getCurrentQr = () => {
    if (qrcodes.length > 0) {
      const index = Math.min(qrIndex, qrcodes.length - 1);
      return qrcodes[index];
    }
    const fallbackPath = cliVendaMostrarDetalhes?.QRCODE_PATH;
    if (fallbackPath) {
      return { path: fallbackPath, url: getQrUrl(fallbackPath) };
    }
    return null;
  };

  const toQrItem = (path) => {
    if (!path) return null;
    return {
      path,
      url: getQrUrl(path),
    };
  };

  const createShareImage = async () => {
    if (!cliVendaMostrarDetalhes) {
      throw new Error("Sem dados da venda para compartilhar.");
    }
    const width = 760;
    const height = 920;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#0f172a";
    ctx.fillRect(0, 0, width, height);
    ctx.textBaseline = "top";
    ctx.fillStyle = "#f8fafc";
    ctx.font = '600 32px "Inter", sans-serif';
    ctx.fillText("Detalhes da Venda", 48, 48);

    const valorBrl = Number(cliVendaMostrarDetalhes?.VALORBRL || 0);
    const valorBob = Number(cliVendaMostrarDetalhes?.VALORBOB || 0);
    const dataTexto = cliVendaMostrarDetalhes?.DATA || cliVendaMostrarDetalhes?.DATA_VENDA || "";

    const infos = [
      { label: "Nome", value: cliVendaMostrarDetalhes?.NOME_CLIENTE || cliVendaMostrarDetalhes?.NOMEBRL || "—" },
      { label: "Valor Reais", value: fmtBRL.format(valorBrl) },
      { label: "Valor Pesos Bolivianos", value: fmtBOB.format(valorBob) },
      { label: "Data", value: dataTexto || "—" },
    ];

    let cursorY = 120;
    infos.forEach((info) => {
      ctx.font = '500 16px "Inter", sans-serif';
      ctx.fillStyle = "#94a3b8";
      ctx.fillText(info.label, 48, cursorY);
      ctx.font = '700 22px "Inter", sans-serif';
      ctx.fillStyle = "#f8fafc";
      wrapText(ctx, info.value, 48, cursorY + 24, width - 96, 26);
      cursorY += 80;
    });

    const currentQr = getCurrentQr();
    const rawQrSrc = currentQr?.url;
    if (rawQrSrc) {
      const absoluteQrSrc = new URL(rawQrSrc, window.location.origin).href;
      const qrImage = await loadImageSafe(absoluteQrSrc);
      if (qrImage) {
        const size = 200;
        const left = width - size - 48;
        const top = cursorY + 20;
        ctx.fillStyle = "#111827";
        ctx.fillRect(left - 12, top - 12, size + 24, size + 24);
        ctx.drawImage(qrImage, left, top, size, size);
      }
    }

    const rodape = `Posso transferir seus Bs ${fmtBOB.format(valorBob)} nessa mesma conta de sempre?`;
    ctx.font = '600 18px "Inter", sans-serif';
    ctx.fillStyle = "#c7d2fe";
    wrapText(ctx, rodape, 48, height - 92, width - 96, 24);

    return canvas.toDataURL("image/png");
  };

  const handleShareLink = async () => {
    if (!cliVendaMostrarDetalhes) {
      toast.info("Abra os detalhes da venda antes de compartilhar.");
      return;
    }
    setIsSharingLink(true);
    try {
      const dataUrl = await createShareImage();
      const payload = { imageData: dataUrl, expiresHours: 24 };
      const response = await api.post("/compartilhamentos", payload);
      const urlPath = response?.data?.url;
      if (!urlPath) throw new Error("Resposta inválida do servidor.");
      const base = baseURL && baseURL.startsWith("http") ? baseURL : window.location.origin;
      const shareUrl = new URL(urlPath, base).href;
      const mensagem = getShareMessage(shareUrl);
      if (navigator?.share) {
        await navigator.share({
          title: "Detalhes da Venda",
          text: mensagem,
          url: shareUrl,
        });
      } else {
        window.open(`https://wa.me/?text=${encodeURIComponent(mensagem)}`, "_blank", "noopener");
      }
      toast.success("Link gerado e pronto para o WhatsApp.");
    } catch (error) {
      console.error("Erro ao gerar o compartilhamento:", error);
      toast.error("Não foi possível gerar o compartilhamento. Tente novamente.");
    } finally {
      setIsSharingLink(false);
    }
  };

 
  // Alterna modo de conferência e salva ao desativar
  const handleToggle = () => {
    setConferencia((prev) => {
      const next = !prev;
      if (prev) {
        // Saindo do modo conferência: salvar
        try {
          setIsLoading?.(true);
          enviarConfPai?.(dataListTabela);
        } catch (error) {
          console.log(`Erro ao enviar conferência: ${error}`);
        }
      } else {
        toast.warn("Modo de Conferência ATIVO");
      }
      return next;
    });
  };

  async function detalhesvenda(item) {
    setCliVendaMostrarDetalhes({
      ...item,
      QRCODE_PATH: item?.QRCODE_PATH,
    });
    setVendaMostrarDetalhes(true);
    // Carrega lista de QR Codes do cliente
    try {
      const idCli = item?.ID_CLIENTE || item?.IDCLI || item?.ID; // fallback
      if (!idCli) {
        const fallback = toQrItem(item?.QRCODE_PATH);
        setQrcodes(fallback ? [fallback] : []);
        setQrIndex(0);
        return;
      }
      const resp = await api.get(`/clientes/${idCli}/qrcodes`);
      const items = Array.isArray(resp.data?.items) ? resp.data.items : [];
      const qrItemsList = items.map((it) => toQrItem(it.path)).filter(Boolean);
      if (!qrItemsList.length && item?.QRCODE_PATH) {
        const fallbackItem = toQrItem(item.QRCODE_PATH);
        if (fallbackItem) qrItemsList.push(fallbackItem);
      }
      setQrcodes(qrItemsList);
      setQrIndex(0);
    } catch (e) {
      // fallback ao único QR se houver
      const fallbackItem = toQrItem(item?.QRCODE_PATH);
      setQrcodes(fallbackItem ? [fallbackItem] : []);
      setQrIndex(0);
    }
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      toast.error('Apenas imagens JPEG ou PNG são permitidas.');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error('A imagem deve ter no máximo 5MB.');
      return;
    }

    const formData = new FormData();
    formData.append('qrcode', file);

  
    try {
      setIsUploading(true);
      setUploadProgress(0);
      const response = await api.post(`/clientes/${cliVendaMostrarDetalhes?.ID_CLIENTE}/upload-qrcode`, formData, {
        // Não defina Content-Type manualmente; o Axios adiciona o boundary corretamente
        onUploadProgress: (event) => {
          if (!event.total) return;
          const percent = Math.round((event.loaded * 100) / event.total);
          setUploadProgress(percent);
        }
      });
      //console.log("ln 90, response:", response.data);
      toast.success('QR Code atualizado com sucesso!');
      // Atualizar o estado com o novo caminho do QR Code e forçar refresh (cache-busting)
      const savedPath = response.data.qrcodePath;
      const timestampedUrl = `${getQrUrl(savedPath)}?t=${Date.now()}`;
      setCliVendaMostrarDetalhes((prev) => ({
        ...prev,
        QRCODE_PATH: savedPath,
      }));
      // Adiciona imagem no início do carrossel
      const newItem = { path: savedPath, url: timestampedUrl };
      setQrcodes((prev) => [newItem, ...prev]);
      setQrIndex(0);
      if (fileInputRef.current) fileInputRef.current.value = '';
      setErroAoSalvarVenda(false); // Sucesso, sem erro
    } catch (error) {
      console.error('Erro ao enviar QR Code:', error);
      toast.error(error.response?.data?.error || 'Erro ao enviar QR Code.');
      setErroAoSalvarVenda(true); // Erro, ativa mensagem
    } finally {
      setIsUploading(false);
    }
  };

  function fechardetalhesvenda() {
    setVendaMostrarDetalhes(false);
    setCliVendaMostrarDetalhes(null); // Limpa o estado ao fechar
    setQrcodes([]);
    setQrIndex(0);
  }

  const handleEditQrCode = () => {
    fileInputRef.current.click(); // Dispara o input de arquivo
  };

  const handleDeleteQrCode = async () => {
    const currentQr = getCurrentQr();
    if (!currentQr?.path) {
      toast.info("Abra um QR Code antes de deletar.");
      return;
    }
    if (!cliVendaMostrarDetalhes?.ID_CLIENTE) {
      toast.error("Cliente não identificado.");
      return;
    }
    const confirmar = await confirm("Deseja remover esta imagem do cliente?");
    if (!confirmar) return;
    setIsDeletingQr(true);
    try {
      await api.delete(`/clientes/${cliVendaMostrarDetalhes.ID_CLIENTE}/qrcodes`, {
        data: { path: currentQr.path },
      });
      setQrcodes((prev) => prev.filter((item) => item.path !== currentQr.path));
      setQrIndex(0);
      setCliVendaMostrarDetalhes((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          QRCODE_PATH: prev.QRCODE_PATH === currentQr.path ? "" : prev.QRCODE_PATH,
        };
      });
      toast.success("Imagem removida.");
    } catch (error) {
      console.error("Erro ao remover QR Code:", error);
      toast.error("Não foi possível remover a imagem.");
    } finally {
      setIsDeletingQr(false);
    }
  };

  const handleCopyImage = async () => {
    try {
      const currentQr = getCurrentQr();
      const rawSrc = currentQr?.url || getQrUrl(cliVendaMostrarDetalhes?.QRCODE_PATH);
      if (!rawSrc) {
        toast.info('Nenhuma imagem para copiar.');
        return;
      }
      const src = new URL(rawSrc, window.location.origin).href;

      // Tentativa 1: Clipboard API moderna (quando disponível)
      if (navigator?.clipboard && window.ClipboardItem) {
        try {
          const resp = await fetch(src, { cache: 'no-store' });
          const blob = await resp.blob();
          const mime = (blob.type && blob.type.startsWith('image/')) ? blob.type : 'image/png';
          await navigator.clipboard.write([
            new window.ClipboardItem({ [mime]: blob })
          ]);
          toast.success('Imagem copiada para a área de transferência.');
          return;
        } catch (e) {
          // segue para fallback
        }
      }

      // Tentativa 2 (fallback): copiar via seleção + execCommand
      try {
        const resp = await fetch(src, { cache: 'no-store' });
        const blob = await resp.blob();
        const tmpUrl = URL.createObjectURL(blob);
        const hidden = document.createElement('div');
        hidden.contentEditable = 'true';
        hidden.style.position = 'fixed';
        hidden.style.left = '-9999px';
        const img = document.createElement('img');
        img.src = tmpUrl;
        hidden.appendChild(img);
        document.body.appendChild(hidden);
        const range = document.createRange();
        range.selectNodeContents(hidden);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        const ok = document.execCommand('copy');
        sel.removeAllRanges();
        document.body.removeChild(hidden);
        URL.revokeObjectURL(tmpUrl);
        if (ok) {
          toast.success('Imagem copiada para a área de transferência.');
          return;
        }
      } catch (e) {
        // continua para o próximo fallback
      }

      // Tentativa 3: abrir a imagem em nova aba para cópia manual
      window.open(src, '_blank', 'noopener');
      toast.info('Abrimos a imagem em nova aba. Toque e segure para copiar.');
    } catch (e) {
      toast.error('Não foi possível copiar a imagem.');
    }
  };

  // Removido salvarConferencia em favor do handleToggle

  const toggleConfirmField = (id, field) => {
    const opposite = field === 'CONFVALORBRL' ? 'CONFVALORBOB' : 'CONFVALORBRL';
    const updatedDataList = dataList.map((item) =>
      item.ID === id ? { ...item, [field]: item[field] === "1" ? "0" : "1" } : item
    );
    setDataList(updatedDataList);
    const updatedItem = updatedDataList.find((item) => item.ID === id);
    setDataListTabela((prev) => ({
      ...prev,
      [id]: {
        ID: id,
        CONFVALORBRL: (field === 'CONFVALORBRL' ? updatedItem.CONFVALORBRL : (updatedItem.CONFVALORBRL ?? "0")),
        CONFVALORBOB: (field === 'CONFVALORBOB' ? updatedItem.CONFVALORBOB : (updatedItem.CONFVALORBOB ?? "0")),
      },
    }));
  };

  const itensFiltradosOrdenados = useMemo(() => {
    if (!Array.isArray(dataList)) return [];
    const dataFilInicio = filtrosDoVendas?.dataInicio || null;
    const dataFilFim = filtrosDoVendas?.dataFim || null;
    const nomeFil = (filtrosDoVendas?.nomeFiltro || '').toUpperCase();
    const filtrados = dataList.filter((item) => {
      const itemDataFormatada = item?.DATA || null;
      const itemNomeFormatado = (item?.NOME_CLIENTE || item?.NOMEBRL || '').toUpperCase();
      if (!dataFilInicio && !dataFilFim && !nomeFil) return true;
      if (!dataFilInicio && !dataFilFim && nomeFil) return itemNomeFormatado.includes(nomeFil);
      if (dataFilInicio && !dataFilFim && !nomeFil) return itemDataFormatada >= dataFilInicio;
      if (dataFilInicio && !dataFilFim && nomeFil) return itemDataFormatada >= dataFilInicio && itemNomeFormatado.includes(nomeFil);
      if (!dataFilInicio && dataFilFim && !nomeFil) return itemDataFormatada <= dataFilFim;
      if (!dataFilInicio && dataFilFim && nomeFil) return itemDataFormatada <= dataFilFim && itemNomeFormatado.includes(nomeFil);
      if (dataFilInicio && dataFilFim && !nomeFil) return itemDataFormatada >= dataFilInicio && itemDataFormatada <= dataFilFim;
      if (dataFilInicio && dataFilFim && nomeFil) return itemDataFormatada >= dataFilInicio && itemDataFormatada <= dataFilFim && itemNomeFormatado.includes(nomeFil);
      return false;
    });
    return filtrados.sort((a, b) => b.DATA.localeCompare(a.DATA));
  }, [dataList, filtrosDoVendas]);

  useEffect(() => {
    // Ao alterar filtros, reexibe o aviso (se não houver resultados)
    setShowAviso(true);
  }, [filtrosDoVendas]);

  const vendasTotais = useMemo(() => {
    return itensFiltradosOrdenados.reduce(
      (acc, item) => {
        const percBRL = parseFloat(item.PERCBRL || 0);
        return {
          BRL: acc.BRL + parseFloat(item.VALORBRL || 0),
          BOB: acc.BOB + parseFloat(item.VALORBOB || 0),
          LBOB: acc.LBOB + parseFloat(item.LUCROBOB || 0),
          LBRL: acc.LBRL + parseFloat(item.LUCROBRL || 0),
          PBRL: acc.PBRL + percBRL,
          count: acc.count + (isNaN(percBRL) ? 0 : 1),
        };
      },
      { BRL: 0, BOB: 0, LBOB: 0, LBRL: 0, PBRL: 0, count: 0 }
    );
  }, [itensFiltradosOrdenados]);

  // Utilitários de exportação
  const fmtPtBRNumber = (n, decimals = 2) => {
    const num = Number(n || 0);
    return num.toFixed(decimals).replace(".", ",");
  };
  const fmtDateDDMMYYYY = (iso) => {
    if (!iso) return "";
    // iso esperado: YYYY-MM-DD
    const [y, m, d] = String(iso).split("-");
    if (!y || !m || !d) return "";
    return `${d}${m}${y}`;
  };
  const onlyDigits = (s) => String(s || "").replace(/\D+/g, "");
  const safeName = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9_-]+/g, "_");

  const downloadTxt = (filename, content) => {
    try {
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      toast.error("Falha ao iniciar download do arquivo.");
    }
  };

  const exportarCompras = () => {
    try {
      if (tabelaOperacao !== 'COMPRA') {
        toast.warn('Mude para a aba COMPRA para exportar.');
        return;
      }
      const items = itensFiltradosOrdenados || [];
      if (!Array.isArray(items) || items.length === 0) {
        toast.info('Nenhuma compra para exportar com os filtros atuais.');
        return;
      }

      // Agrupa por EXCHANGE (1 = Sem Exchange, 2 = Exchange Exterior)
      const grupos = items.reduce((acc, it) => {
        const k = Number(it.EXCHANGE || 0);
        acc[k] = acc[k] || [];
        acc[k].push(it);
        return acc;
      }, {});

      const periodo = (() => {
        const i = filtrosDoVendas?.dataInicio ? filtrosDoVendas.dataInicio.replace(/-/g, "") : "";
        const f = filtrosDoVendas?.dataFim ? filtrosDoVendas.dataFim.replace(/-/g, "") : "";
        return i && f ? `${i}-${f}` : (i || f || new Date().toISOString().slice(0,10).replace(/-/g, ""));
      })();

      // Leiaute 2 — Exchange no Exterior (EXCHANGE === 2)
      if (Array.isArray(grupos[2]) && grupos[2].length) {
        const linhas = grupos[2].map((it) => {
          const registro = '0110'; // código do registro para compras
          const data = fmtDateDDMMYYYY(it.DATA);
          const tipo = 'I'; // Intermediada
          const valorBRL = fmtPtBRNumber(it.VALORBRL, 2);
          const comissao = fmtPtBRNumber(it.EXCHANGE_COMISSAO || 0, 2);
          const cripto = 'USDT';
          const usdtQuant = fmtPtBRNumber(it.USDT_QUANT || (Number(it.VALORBRL || 0) / Number(it.USDT_PRECO_UN || 1)), 8);
          const exchangeNome = 'Binance'; // padrão adotado no app
          const exchangeUrl = 'https://www.binance.com';
          const uf = 'MT'; // UF do declarante (ajuste se necessário)
          return [registro, data, tipo, valorBRL, comissao, cripto, usdtQuant, exchangeNome, exchangeUrl, uf].join('|');
        });
        const conteudo = linhas.join("\r\n") + "\r\n";
        const nomeArq = `ARQ_CRIPTO_Leiaute2_ExchangeExterior_${periodo}.txt`;
        downloadTxt(nomeArq, conteudo);
      }

      // Leiaute 3 — Sem Exchange (EXCHANGE === 1)
      if (Array.isArray(grupos[1]) && grupos[1].length) {
        const linhas = grupos[1].map((it) => {
          const registro = '0110'; // código do registro para compras
          const data = fmtDateDDMMYYYY(it.DATA);
          const tipo = 'I';
          const valorBRL = fmtPtBRNumber(it.VALORBRL, 2);
          const comissao = fmtPtBRNumber(0, 2);
          const cripto = 'USDT';
          const usdtQuant = fmtPtBRNumber(it.USDT_QUANT || (Number(it.VALORBRL || 0) / Number(it.USDT_PRECO_UN || 1)), 8);
          // Pessoa física por padrão (1) com CPF e Nome
          const pessoaIndicador = '1';
          const pais = 'BR';
          const cpf = onlyDigits(it.CPF || '');
          const cnpj = '';
          const nome = String(it.NOME_CLIENTE || it.NOMEBRL || '').toUpperCase();
          return [registro, data, tipo, valorBRL, comissao, cripto, usdtQuant, pessoaIndicador, pais, cpf, cnpj, nome].join('|');
        });
        const conteudo = linhas.join("\r\n") + "\r\n";
        const nomeArq = `ARQ_CRIPTO_Leiaute3_SemExchange_${periodo}.txt`;
        downloadTxt(nomeArq, conteudo);
      }

      if ((!grupos[1] || !grupos[1].length) && (!grupos[2] || !grupos[2].length)) {
        toast.info('Compras filtradas não possuem coluna Exchange válida (1 ou 2).');
      } else {
        toast.success('Exportação gerada com base nos filtros.');
      }
    } catch (e) {
      console.error('[exportarCompras] erro', e);
      toast.error('Erro ao gerar exportação.');
    }
  };

  const fmtBRL = useMemo(() => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }), []);
  const fmtBOB = useMemo(() => new Intl.NumberFormat('es-BO', { style: 'currency', currency: 'BOB' }), []);
  const currentQr = getCurrentQr();
  const currentQrUrl = currentQr?.url || "";

  const handleBotaoClick1 = () => {
    navigate("/Clientes");    
  }
  const handleBotaoClick2 = () => {    
    if (typeof limparFiltros === 'function') {
      limparFiltros();
      toast.info('Filtros limpos. Digite para buscar um cliente.');
      return;
    }
    if (typeof setFiltrosDoVendas === 'function') {
      setFiltrosDoVendas({ dataInicio: null, dataFim: null, nomeFiltro: '' });
      toast.info('Filtros limpos. Digite para buscar um cliente.');
      return;
    }
    // Sem navegação para evitar sair da sessão; apenas informa
    toast.info('Limpe os filtros na barra de busca para recomeçar.');
  }


  return (
    <div className={cx('venda-tabeladiv')}>
      <ConfirmModal />
      <div className={cx('venda-export-conferencia')}>
        {tabelaOperacao === 'COMPRA' && itensFiltradosOrdenados.length > 0 && (
          <div className={cx('venda-export-compras')}>
            <button type="button" onClick={exportarCompras} className={`${ui.butmobile}`} title="Exportar compras filtradas por Exchange">
              Exportar Compras (por Exchange)
            </button>
          </div>
        )}
        {Array.isArray(dataList) && dataList.length > 0 ? (
          <div className={cx('venda-conferencia')}>
            <ToggleSwitch
              checked={conferencia}
              onChange={handleToggle}
              labelOn="SALVAR e Sair do modo de Conferência"
              labelOff="ATIVAR Modo de Conferência!"
            />
          </div>
        ) : (
          <span></span>
        )}
      </div>
      {/*console.log("ln 226, vendaMostrarDetalhes", vendaMostrarDetalhes)*/}
      <div className={`${cx('venda-detalhes')} ${vendaMostrarDetalhes ? cx('active') : ''}`}>
        <div className={cx('venda-detalhes-container')}>
          <button className={cx('venda-fechar-detalhes')} onClick={fechardetalhesvenda} title="Fechar" aria-label="Fechar detalhes da venda">
            <FiX />
          </button>
          <div className={cx('venda-detalhes-container-2')}>
            <div className={`${cx('venda-qr')} ${isUploading ? cx('uploading') : ''}`}>

              {/*src={`${baseURL}/logoBanco/${item.QRCODE_PATH.split('/').pop()}`}*/}
              {/*console.log("ln 238, cliVendaMostrarDetalhes:", cliVendaMostrarDetalhes)*/}
      <img
  src={currentQrUrl || ""}
  alt={cliVendaMostrarDetalhes?.NOME_CLIENTE || cliVendaMostrarDetalhes?.NOMEBRL || "QR Code"}
  loading="lazy"
  className={cx('venda-qr-img')}
  role="button"
  tabIndex={0}
  aria-label="Ampliar QR Code"
  onClick={() => {
    setQrFullscreenSrc(currentQrUrl);
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setQrFullscreenSrc(currentQrUrl);
    }
  }}
/>
              {qrcodes.length > 1 && (
                <div className={cx('qr-nav')}>
                  <div className={cx('divqr-btn-anterior')}>
                    <button
                      className={cx('btnAnterior')}
                      type="button"
                      onClick={() => setQrIndex((prev) => (prev - 1 + qrcodes.length) % qrcodes.length)}
                      aria-label="Anterior">                  
                      ◀
                    </button>
                  </div>
                  <div className={cx('divqr-btn-meio')}>
                    <span>{qrIndex + 1}/{qrcodes.length}</span>
                  </div>
                  <div className={cx('divqr-btn-proximo')}>
                    <button
                      className={cx('btnProximo')}
                      type="button"
                      onClick={() => setQrIndex((prev) => (prev + 1) % qrcodes.length)}
                      aria-label="Próximo"
                    >
                      ▶
                    </button>
                  </div>
                </div>
              )}
              <div className={cx('qr-actions')}>
                <button className={cx('qr-adicionar-btn')} onClick={handleEditQrCode} aria-label="Editar QR Code" disabled={isUploading} title="Adicionar QR Code">
                  <FiPlus />
                </button>
                <button
                  className={cx('qr-delete-btn')}
                  onClick={handleDeleteQrCode}
                  aria-label="Remover QR Code"
                  disabled={isUploading || isDeletingQr}
                  title="Remover QR Code"
                >
                  <FiTrash2 />
                </button>
                {isUploading && (
                  <div className={cx('qr-overlay')} aria-live="polite">
                    <div className={cx('qr-spinner')} />
                    <div className={cx('qr-progress')}>
                  <div className={cx('qr-progress-bar')} style={{ width: `${uploadProgress}%` }} />
                    </div>
                    <span className={cx('qr-progress-text')}>Enviando {uploadProgress}%</span>
                  </div>
                )}
              </div>
              <input
                type="file"
                ref={fileInputRef}
                className={cx('hidden-file-input')}
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
              />
            </div>
            <div className={cx('venda-nome')}>
              <label htmlFor="nomeBRL">Nome:</label>
              <span>{cliVendaMostrarDetalhes?.NOME_CLIENTE || cliVendaMostrarDetalhes?.NOMEBRL || 'N/A'}</span>
            </div>
            <div className={cx('venda-devalorbrl')}>
              <label htmlFor="valorBRL">Valor Reais:</label>
              <span>{fmtBRL.format(cliVendaMostrarDetalhes?.VALORBRL || 0)}</span>
            </div>
            <div className={cx('venda-devalorbob')}>
              <label htmlFor="valorBOB">Valor Pesos Bolivianos:</label>
              <span>{fmtBOB.format(cliVendaMostrarDetalhes?.VALORBOB || 0)}</span>
            </div>
            <div className={cx('venda-share')}>
              <p className={cx('venda-share-text')}>{`Posso transferir seus ${fmtBOB.format(Number(cliVendaMostrarDetalhes?.VALORBOB || 0))} nessa mesma conta?`}</p>
              <div className={cx('venda-sharebtn')}> 
                <button type="button" className={cx('venda-share-btn','venda-copyimg-btn')} onClick={handleCopyImage} aria-label="Copiar imagem" aria-hidden="true">
                  <FiCopy />
                  <span>Copiar Imagem</span>
                </button>
                <button type="button" className={cx('venda-share-btn','venda-copytext-btn')} onClick={handleShareWhats} aria-label="Copiar mensagem" aria-hidden="true">
                  <FiCopy />
                  <span>Copiar Texto</span>
                </button>
                <button
                  type="button"
                  className={cx('venda-share-btn', 'venda-share-link-btn')}
                  onClick={handleShareLink}
                  disabled={isSharingLink}
                  aria-label="Compartilhar venda no WhatsApp"
                >
                  <FiShare2 />
                  <span>{isSharingLink ? "Gerando link..." : "Compartilhar"}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {qrFullscreenSrc && (
        <div
          className={cx('qr-fullscreen-overlay')}
          role="dialog"
          aria-modal="true"
          aria-label="Visualização ampliada do QR Code"
          onClick={() => setQrFullscreenSrc(null)}
        >
          <img
            src={qrFullscreenSrc}
            alt="QR Code em tela cheia"
            onClick={(e) => e.stopPropagation()}
            className={cx('qr-fullscreen-img')}
          />
          <button
            type="button"
            className={cx('qr-fullscreen-close')}
            aria-label="Fechar"
            onClick={(e) => {
              e.stopPropagation();
              setQrFullscreenSrc(null);
            }}
          >
            ×
          </button>
        </div>
      )}
      {itensFiltradosOrdenados.length > 0 ? (
        <div className={cx('venda-tabela-pretab')}>
          <div className={cx('venda-divtabela')}>
            <div className={cx('tableWrap', 'tableScroll')}>
              <table className={`${ui.venda_tabela}`} border="1">
              <thead>
                <tr>
                  <th scope="col" className={ui.colthead_compra}>Compra</th>
                  <th scope="col" className={ui.colthead_data}>Data</th>
                  <th scope="col" className={ui.colthead_nomebrl}>Nome BRL</th>
                  <th scope="col" className={ui.colthead_nomebob}>Nome BOB</th>
                  <th scope="col" className={ui.colthead_valorbrl}>Valor BRL</th>
                  <th scope="col" className={ui.colthead_valorbob}>Valor BOB</th>
                  
                  {tabelaOperacao === 'COMPRA' ? (
                    
                    <>
                      <th scope="col" className={ui.colthead_exchange}>Exchange</th>
                      <th scope="col" className={ui.colthead_usdtqtd}>USDT Quant</th>
                      <th scope="col" className={ui.colthead_usdtpreco}>USDT Preço</th>
                    </>
                  ) : (
                    <>
                      <th scope="col" className={ui.colthead_taxadia}>Taxa do Dia</th>
                      <th scope="col" className={ui.colthead_lucrobob}>Lucro BOB</th>
                      <th scope="col" className={ui.colthead_lucrobrl}>Lucro BRL</th>
                      <th scope="col" className={ui.colthead_percbrl}>%BRL</th>
                    </>
                  )}
                  <th scope="col" className={cx('venda-col-acoes')}>Ações</th>
              </tr>
              </thead>
              <tbody>
                {itensFiltradosOrdenados.map((item) => (
                  <tr key={item.ID}>
                    <td className={`${ui.col_compra} ${cx('venda-abrir-detalhes')}`} data-label="Compra" onClick={() => detalhesvenda(item)} title={item.COMPRABOBDIA}>{item.COMPRABOBDIA}</td>
                    <td className={ui.col_data} data-label="Data" title={new Date(`${item.DATA}T00:00:00`).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}>{new Date(`${item.DATA}T00:00:00`).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                    <td className={ui.col_nomebrl} title={item.NOME_CLIENTE} data-label="Nome">{item.NOME_CLIENTE || item.NOMEBRL}</td>
                    <td className={ui.col_nomebob} title={item.NOMEBOB} data-label="Nome BOB">{item.NOMEBOB}</td>
                    <td className={`${ui.col_valorbrl} ${cx('confBrl')}`} data-label="Valor BRL" title={fmtBRL.format(item.VALORBRL)}>
                      <div>
                        {conferencia ? (
                          <span role="button" aria-pressed={item.CONFVALORBRL === "1"} title="Confirmar valor BRL" key={`listBrl-${item.ID}`} onClick={() => toggleConfirmField(item.ID, 'CONFVALORBRL')}>
                            {item.CONFVALORBRL !== "1" ? <FiToggleLeft className={cx('toggle-inactive-brl')} /> : <FiToggleRight className={cx('toggle-active-brl')} />}
                          </span>
                        ) : null}
                        <span>{fmtBRL.format(item.VALORBRL)}</span>
                      </div>
                    </td>
                    <td className={`${ui.col_valorbob} ${cx('confBob')}`} data-label="Valor BOB" title={fmtBOB.format(item.VALORBOB)}>
                      <div>
                        {conferencia ? (
                          <span role="button" aria-pressed={item.CONFVALORBOB === "1"} title="Confirmar valor BOB" key={`listBob-${item.ID}`} onClick={() => toggleConfirmField(item.ID, 'CONFVALORBOB')}>
                            {item.CONFVALORBOB !== "1" ? <FiToggleLeft className={cx('toggle-inactive-bob')} /> : <FiToggleRight className={cx('toggle-active-bob')} />}
                          </span>
                        ) : null}
                        <span>{fmtBOB.format(item.VALORBOB)}</span>
                      </div>
                    </td>
                    {tabelaOperacao === 'COMPRA' ? (
                      <>
                        <td className={cx('col_exchange')} data-label="Exchange" title={(() => {
                          const v = Number(item.EXCHANGE || 0);
                          return v === 2 ? 'COM' : 'SEM';
                        })()}
                        >
                          {(() => {
                          const v = Number(item.EXCHANGE || 0);
                          return v === 2 ? 'COM' : 'SEM';
                        })()}</td> 
                        <td className={cx('col_usdtqtd')} data-label="USDT Quant" title={Number(item.USDT_QUANT || 0).toFixed(8)}>{Number(item.USDT_QUANT || 0).toFixed(8)}</td>
                        <td className={cx('col_usdtpreco')} data-label="USDT Preço" title={Number(item.USDT_PRECO_UN || 0).toFixed(6)}>{Number(item.USDT_PRECO_UN || 0).toFixed(6)}</td>
                      </>
                    ) : (
                      <>
                        <td className={ui.col_taxadia} data-label="Taxa" title={(item.TAXADIA)}>{(item.TAXADIA)}</td>
                        <td className={ui.col_lucrobob} data-label="Lucro BOB" title={item.LUCROBOB}>{item.LUCROBOB}</td>
                        <td className={ui.col_lucrobrl} data-label="Lucro BRL" title={fmtBRL.format(item.LUCROBRL)}>{fmtBRL.format(item.LUCROBRL)}</td>
                        <td className={ui.col_percbrl} data-label="%BRL" title={Number(item.PERCBRL || 0).toFixed(2) + "%"}>{Number(item.PERCBRL || 0).toFixed(2) + "%"}</td>
                      </>
                    )}
                    <td className={`${cx('venda-col-acoes')} ${cx('venda-acoes')}`} data-label="Ações">
                      <div className={`${ui.buteditarremover}`}>
                        <button title="Editar" className={`${ui.buteditar}`} onClick={() => onEdit(item)}>
                          <FiEdit size={15} />
                        </button>
                        <button title="Excluir" className={`${ui.butremover}`} onClick={() => onDelete(item)}>
                          <FiTrash2 size={15} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className={ui.venda_trtotais}>
                  <td className={ui.col_compra}>Totais</td>
                  <td className={ui.col_data}></td>
                  <td className={ui.col_nomebrl}></td>
                  <td className={ui.col_nomebob}></td>
                  <td className={ui.col_valorbrl}>{fmtBRL.format(vendasTotais.BRL)}</td>
                  <td className={ui.col_valorbob}>{fmtBOB.format(vendasTotais.BOB)}</td>
                  {tabelaOperacao === 'COMPRA' ? (
                    <>
                      <td className={ui.col_exchange}></td>
                      <td className={ui.col_usdtqtd}></td>
                      <td className={ui.col_usdtpreco}></td>
                    </>
                  ) : (
                    <>
                      <td className={ui.col_taxadia}></td>
                      <td className={ui.col_lucrobob}>{vendasTotais.LBOB.toFixed(2)}</td>
                      <td className={ui.col_lucrobrl}>{fmtBRL.format(vendasTotais.LBRL)}</td>
                      <td className={ui.col_percbrl}>{(vendasTotais.count > 0 ? vendasTotais.PBRL / vendasTotais.count : 0).toFixed(2) + "%"}</td>
                    </>
                  )}
                  <td className={cx('venda-col-acoes')}></td>
                </tr>
              </tfoot>
              </table>
            </div>
            {/* Ultra-mobile cards (<360px): alternativa à tabela */}
            <div className={cx('venda-cards')}>
              {itensFiltradosOrdenados.map((item) => (
                <div className={cx('venda-card')} key={`card-${item.ID}`}>
                  <div className={cx('vc-header')}>
                    <span className={cx('vc-compra')} onClick={() => detalhesvenda(item)}>{item.COMPRABOBDIA}</span>
                    <span className={cx('vc-data')}>{new Date(`${item.DATA}T00:00:00`).toLocaleDateString('pt-BR')}</span>
                  </div>
                  <div className={cx('vc-nome')}>{item.NOME_CLIENTE || item.NOMEBRL}</div>
                  <div className={cx('vc-valores')}>
                    <div className={cx('vc-brl')}>
                      {conferencia ? (
                        <span role="button" aria-pressed={item.CONFVALORBRL === "1"} title="Confirmar BRL" onClick={() => toggleConfirmField(item.ID, 'CONFVALORBRL')}>
                          {item.CONFVALORBRL !== "1" ? <FiToggleLeft className={cx('toggle-inactive-brl')} /> : <FiToggleRight className={cx('toggle-active-brl')} />}
                        </span>
                      ) : null}
                      <span>{fmtBRL.format(item.VALORBRL)}</span>
                    </div>
                    <div className={cx('vc-bob')}>
                      {conferencia ? (
                        <span role="button" aria-pressed={item.CONFVALORBOB === "1"} title="Confirmar BOB" onClick={() => toggleConfirmField(item.ID, 'CONFVALORBOB')}>
                          {item.CONFVALORBOB !== "1" ? <FiToggleLeft className={cx('toggle-inactive-bob')} /> : <FiToggleRight className={cx('toggle-active-bob')} />}
                        </span>
                      ) : null}
                      <span>{fmtBOB.format(item.VALORBOB)}</span>
                    </div>
                  </div>
                  <div className={cx('vc-metas')}>
                    <span className={cx('vc-taxa')}>Tx: {item.TAXADIA}</span>
                    <span className={cx('vc-lucros')}>L: {fmtBRL.format(item.LUCROBRL)}</span>
                    <span className={cx('vc-perc')}>%: {Number(item.PERCBRL || 0).toFixed(2)}</span>
                  </div>
                  <div className={cx('vc-acoes')}>
                    <button className={cx('venda-editarbtn')} onClick={() => onEdit(item)} aria-label="Editar venda">
                      <FiEdit size={16} />
                    </button>
                    <button className={cx('venda-removerbtn')} onClick={() => onDelete(item)} aria-label="Remover venda">
                      <FiTrash2 size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
        </div>
      ) : (
        <div className={cx('vendas-errocarregarvendas')}>
          {isLoading && <p>Carregando vendas...</p>}
          {erroAoSalvarVenda && (
            <p className={cx('vendas-erro-text')}>Não foi possível carregar as vendas. Tivemos um problema ao conectar com o servidor. Por favor, tente mais tarde!</p>
          )}


          {!isLoading && !erroAoSalvarVenda && (
            
            <ul className={styles['venda-list']}>
              
              {showAviso && (
                <Aviso
                  botaoTexto1={"Ver clientes cadastrados"}
                  botaoTexto2={"Limpar filtros"}
                  mensagem={`Nenhuma venda encontrada${filtrosDoVendas?.nomeFiltro ? ` para "${filtrosDoVendas.nomeFiltro}"` : ''}. Ajuste os filtros ou veja os clientes.`}
                  onBotaoClick1={handleBotaoClick1}
                  onBotaoClick2={handleBotaoClick2}
                  onClose={() => setShowAviso(false)}
                />
              )}
              {(Array.isArray(dataList) ? dataList : []).map((item, idx) => (
                <li key={item.ID ?? item.id ?? `v-${idx}`}>{/* exiba os dados de cada venda aqui */}</li>
              ))}
            </ul>
            
          )}
        </div>
      )}

      <div className={`${ui.floatingFab} venda-fab`}>
        <button onClick={toggleFormulario} className={`${ui.novaBtn} ${ui.addBtn}`} aria-label="Adicionar nova venda">
          <FiPlus size={24} />
        </button>
      </div>
    </div>
  );
};

export default Tabela;
